// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/v0.1.1382/css/" + chunkId + "." + {"72":"228fb4d5","111":"228fb4d5"}[chunkId] + ".chunk.css";
};